"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponValueType = exports.CouponType = void 0;
var CouponType;
(function (CouponType) {
    CouponType["Luncheon"] = "LUNCHEON";
    CouponType["Fidelity"] = "FIDELITY";
    CouponType["Voucher"] = "VOUCHER";
    CouponType["Sponsorship"] = "SPONSORSHIP";
    CouponType["Refund"] = "REFUND";
    CouponType["Participation"] = "PARTICIPATION";
})(CouponType || (exports.CouponType = CouponType = {}));
var CouponValueType;
(function (CouponValueType) {
    CouponValueType["Percent"] = "PERCENT";
    CouponValueType["Value"] = "VALUE";
    CouponValueType["Product"] = "PRODUCT";
})(CouponValueType || (exports.CouponValueType = CouponValueType = {}));
exports.default = {
    CouponType: CouponType,
    CouponValueType: CouponValueType,
};
//# sourceMappingURL=Coupons.js.map